import * as React from "react";
import { AutoCompleteInput, Checkbox, Input, Label } from "uxp/components";
import { findAvailableFields, IBaseProperty, IUIPropertyDefinition } from "../../../common/common";
import { CustomColorPicker, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle } from "../../../common/ui-props/common";
import jp from 'jsonpath'
import { IDataSource, IDataSourceBinding } from "../../../common/data-source-picker/datasource";
import IconEditor from "../../../common/icon-selector/IconEditor";
import { Conditional } from "../../../common/ConditionalComponent";
import { DataSourcePropertyEditor } from "../../../common/ui-props/DataSourceProperty";
import { bindContainerId } from "../../../../util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

export interface IBoxProps {
    label: string,
    labelColor: string,
    icon: string,
    iconColor: string,
    fieldName: string,
    defaultValue: any,
    backgroundColor: string,
    datasource: IDataSourceBinding,
}

export interface IGridLayoutWidgetProps {

    boxProps: IBoxProps[],

}
export interface IGridLayoutCommonProps {
    showBorder: boolean;
    orientation: 'Row' | 'Column' ,
    borderColor:string
}

export function GridLayoutCommonProps(commonWidgetProps: IGridLayoutCommonProps): IUIPropertyDefinition<IGridLayoutCommonProps> {

    return {
        defaults: commonWidgetProps,
        render: (props, uxpContext, contextData, containerId) => {
            let _props = props.uiProps
            let borderColor = props?.uiProps.borderColor
            return <>
                {
                    <PropertyContainer>
                        <PropertyContainerTitle>Common Properties</PropertyContainerTitle>
                        <PropertyGroup>
                                <Property>
                                    <PropertyTitle>Content Alignment</PropertyTitle>

                                        <div className="donut-chart-type-selector-container">
                                        <div className={classNames("type", { 'selected': commonWidgetProps?.orientation == 'Column' })} onClick={() => {
                                            jp.apply(commonWidgetProps, '$.orientation', () => ('Column'))
                                            props.onChange(_props)
                                        }}>
                                            <FontAwesomeIcon icon={['fas', 'arrow-down']} />
                                        </div>

                                        <div className={classNames("type", { 'selected': commonWidgetProps?.orientation == 'Row' })} onClick={() => {
                                            jp.apply(commonWidgetProps, '$.orientation', () => ('Row'))
                                            props.onChange(_props)
                                        }}>
                                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                                        </div>

                                    </div>
                                </Property>
                                <Property>
                                    <PropertyTitle>Border Color</PropertyTitle>
                                    <CustomColorPicker contextData={props.contextData}
                                        color={borderColor || 'white'}
                                        onChange={s => {
                                            jp.apply(_props, `borderColor`, () => (s))
                                            props.onChange(_props)
                                        }}
                                    />
                                
                                </Property>
                                <Property>
                            <Checkbox
                                checked={_props?.showBorder}
                                onChange={s => {
                                    jp.apply(_props, '$.showBorder', () => (s))
                                    props.onChange(_props)
                                }}
                                label="Show Border"
                            />

                        </Property>
                            </PropertyGroup>
                    </PropertyContainer>
                    
                }
            </>
        }
    };
}
export type SelectablePart = 'icon' | 'label' | 'value' | 'all'

export let defaultBoxProps: IBoxProps = {
    label: 'Sample Text',
    labelColor: '#FFFFFF88',

    icon: 'angleUp',
    iconColor: '#FFFFFF88',
    fieldName: '',
    defaultValue: '537',
    backgroundColor: '000000',
    datasource: null,
};

interface ITextProperty extends IBaseProperty {
    text: string;
}

interface IDropDownPropertySettings {
    minValue?: number,
    maxValue?: number
}

export function NumberInput(title: string, props: ITextProperty, settings: IDropDownPropertySettings = {}): IUIPropertyDefinition<ITextProperty> {
    const getValue = (v: number) => {
        if (v > settings.maxValue) return settings.maxValue;
        if (v < settings.minValue) return settings.minValue;
        return v;
    }

    return {
        defaults: props,
        
        render: (props) => {
            return <div className='wd-prop-item'>
                <div className='wd-prop-item-title'>{title}</div>
                <div className='wd-prop-item-editor'>
                    <Label>No.of Box</Label>
                    <Input
                        type="number"
                        value={props.uiProps.text || ''}
                        onChange={s => props.onChange(Object.assign({}, props.uiProps, { text: getValue(parseInt(s)) }))}
                        className="widget-designer-input"
                    />
                </div>

            </div>;
        }
    };
}

export function GridLayoutWidgetProperty(widgetProps: IGridLayoutWidgetProps): IUIPropertyDefinition<IGridLayoutWidgetProps> {

    return {
        defaults: widgetProps,
        render: (props, uxpContext, contextData, containerId) => {
            let _props = props.uiProps
            let { selectedIndex, selectedPart } = contextData
            let sources: IDataSource[] = props?.parentUIProps?.datasources
            let selectedBoxProp = widgetProps?.boxProps[selectedIndex];
            if (!selectedBoxProp) selectedBoxProp = defaultBoxProps

            let source = selectedBoxProp?.datasource

            let possibleValues = {};
            findAvailableFields(source, sources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();

            return <>
                {
                    <PropertyContainer>
                        <PropertyContainerTitle>Box Properties</PropertyContainerTitle>
                        <Conditional visible={selectedPart == 'all' || selectedPart == 'value'}>
                            <PropertyGroup>
                                <Property id={bindContainerId('field-name-' + selectedIndex, containerId)}>
                                    <PropertyTitle>Field Name</PropertyTitle>
                                    <AutoCompleteInput
                                        value={selectedBoxProp?.fieldName || ''}
                                        onChange={s => {
                                            jp.apply(_props, `$.boxProps[${selectedIndex}].fieldName`, () => (s))
                                            props.onChange(_props)
                                        }}
                                        className="widget-designer-input"
                                        options={pv}
                                    />
                                </Property>

                                <Property>
                                    <PropertyTitle>Default Value</PropertyTitle>
                                    <Input
                                        value={selectedBoxProp?.defaultValue || ''}
                                        onChange={s => {
                                            jp.apply(_props, `$.boxProps[${selectedIndex}].defaultValue`, () => (s))
                                            props.onChange(_props)
                                        }}
                                        className="widget-designer-input"
                                    />
                                </Property>
                            </PropertyGroup>
                        </Conditional>

                        <Conditional visible={selectedPart == 'all' || selectedPart == 'value'}>
                            <Property id={bindContainerId('field-data-source-' + selectedIndex, containerId)}>
                                <DataSourcePropertyEditor
                                    title={'Source'}
                                    binding={source}
                                    sources={sources}
                                    target={'dictionary'}
                                    onChange={s => {
                                        jp.apply(_props, `$.boxProps[${selectedIndex}].datasource`, () => (s))
                                        props.onChange(_props)
                                    }}
                                    designer={props.designer}
                                    onChangeAny={props.onChangeAny}
                                    context={props.uxpContext}
                                    contextData={props.contextData}
                                />
                            </Property>
                        </Conditional>
                        <Conditional visible={selectedPart == 'all'}>
                            <PropertyGroup>
                                <Property>
                                    <PropertyTitle>Background Color</PropertyTitle>
                                    <CustomColorPicker contextData={props.contextData}
                                        color={selectedBoxProp?.backgroundColor || 'white'}
                                        onChange={s => {
                                            jp.apply(_props, `$.boxProps[${selectedIndex}].backgroundColor`, () => (s))
                                            props.onChange(_props)
                                        }}
                                    />
                                </Property>
                            </PropertyGroup>
                        </Conditional>

                        <Conditional visible={selectedPart == 'all' || selectedPart == 'label'}>
                            <PropertyGroup>
                                <Property>
                                    <PropertyTitle>Label</PropertyTitle>
                                    <Input
                                        value={selectedBoxProp?.label || ''}
                                        onChange={s => {
                                            jp.apply(_props, `$.boxProps[${selectedIndex}].label`, () => (s))
                                            props.onChange(_props)
                                        }}
                                        className="widget-designer-input"
                                    />
                                </Property>

                                <Property>
                                    <PropertyTitle>Label Color</PropertyTitle>
                                    <CustomColorPicker contextData={props.contextData}
                                        color={selectedBoxProp?.labelColor || 'white'}
                                        onChange={s => {
                                            jp.apply(_props, `$.boxProps[${selectedIndex}].labelColor`, () => (s))
                                            props.onChange(_props)
                                        }}

                                    />
                                </Property>
                            </PropertyGroup>
                        </Conditional>

                        <Conditional visible={selectedPart == 'all' || selectedPart == 'icon'}>
                            <PropertyGroup>
                                <Property>
                                    <PropertyTitle>{'Icon'}</PropertyTitle>
                                    <IconEditor
                                        value={selectedBoxProp?.icon || ''}
                                        onChange={s => {
                                            jp.apply(_props, `$.boxProps[${selectedIndex}].icon`, () => (s))
                                            props.onChange(_props)
                                        }}
                                    />
                                </Property>

                                <Property>
                                    <PropertyTitle>Icon Color</PropertyTitle>
                                    <CustomColorPicker contextData={props.contextData}
                                        color={selectedBoxProp?.iconColor || 'white'}
                                        onChange={s => {
                                            jp.apply(_props, `$.boxProps[${selectedIndex}].iconColor`, () => (s))
                                            props.onChange(_props)
                                        }}
                                    />
                                </Property>
                            </PropertyGroup>
                            
                        </Conditional>
                    </PropertyContainer>
                    
                }
            </>
        }
    };
}
